import { GetProjectEstimatesQuery } from '@/gql/graphql';
import { Accordion, Badge, Card } from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';
import { FC } from 'react';
import EstimateCard from './EstimateCard';

type Estimate = GetProjectEstimatesQuery['projectById']['estimates'][number];

type Props = {
  projectId: string;
  estimates: Estimate[];
};

const ArchivedEstimatesSection: FC<Props> = (props) => {
  const { projectId, estimates } = props;

  if (estimates.length === 0) return null;

  return (
    <Card className="bg-gray-50">
      <Card.Body>
        <Accordion
          panelClassName="mt-3 space-y-3"
          title={
            <h4 className="flex items-center gap-2 text-left">
              <UntitledIcon name="archive" className="size-4" />
              Archived estimates
              <Badge variant="white" size="sm" rounded>
                {estimates.length}
              </Badge>
            </h4>
          }
        >
          {estimates.map((estimate) => (
            <EstimateCard
              key={estimate.id}
              projectId={projectId}
              estimate={estimate}
            />
          ))}
        </Accordion>
      </Card.Body>
    </Card>
  );
};

export default ArchivedEstimatesSection;
